import { rootApi } from '../rootApi';

export const lmsTrainingDocumentApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        addLmsTrainingDocument: builder.mutation({
            query: ({ vehicleTrainingMatchId, description, file, isPublic }) => {
                const formData = new FormData();
                formData.append('VehicleTrainingMatchId', vehicleTrainingMatchId);
                formData.append('Description', description);
                formData.append('File', file);
                if (typeof isPublic === 'boolean') formData.append('IsPublic', String(isPublic));

                return {
                    url: 'v1/LmsDocument/Add',
                    method: 'POST',
                    body: formData
                };
            },
            invalidatesTags: [{ type: 'LmsDocument', id: 'LIST' }]
        }),

        getLmsTrainingDocuments: builder.query({
            queryFn: async (vehicleTrainingMatchIds, _queryApi, _extraOptions, fetchWithBQ) => {
                const responses = await Promise.all(
                    vehicleTrainingMatchIds.map((vehicleTrainingMatchId) =>
                        fetchWithBQ({
                            url: 'v1/LmsDocument/GetList',
                            method: 'POST',
                            body: { vehicleTrainingMatchId }
                        })
                    )
                );
                const failedResponse = responses.find((response) => response.error);
                if (failedResponse) return { error: failedResponse.error };

                const documentsById = new Map();
                responses
                    .flatMap((response) => response.data.data.items)
                    .forEach((document) => {
                        documentsById.set(document.documentId, document);
                    });
                return { data: Array.from(documentsById.values()) };
            },
            providesTags: [{ type: 'LmsDocument', id: 'LIST' }]
        }),

        updateLmsTrainingDocument: builder.mutation({
            query: ({ documentId, description, isPublic }) => {
                const formData = new FormData();
                formData.append('DocumentId', documentId);
                formData.append('Description', description);
                if (typeof isPublic === 'boolean') formData.append('IsPublic', String(isPublic));
                return {
                    url: 'v1/LmsDocument/Update',
                    method: 'PUT',
                    body: formData
                };
            },
            invalidatesTags: [{ type: 'LmsDocument', id: 'LIST' }]
        }),

        deleteLmsTrainingDocument: builder.mutation({
            query: ({ documentId }) => ({
                url: `v1/LmsDocument/Delete/${documentId}`,
                method: 'DELETE'
            }),
            invalidatesTags: [{ type: 'LmsDocument', id: 'LIST' }]
        })
    }),
    overrideExisting: false
});

export const { useGetLmsTrainingDocumentsQuery, useAddLmsTrainingDocumentMutation, useUpdateLmsTrainingDocumentMutation, useDeleteLmsTrainingDocumentMutation } = lmsTrainingDocumentApi;
